import script from "./ScenariosPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScenariosPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__